module.exports = __webpack_public_path__ + "static/outcome_icon-12692742cae06bab0cf62dd56e857d1b.svg";